import React, { useMemo } from 'react';
import { useLocation, useParams } from 'umi';
import CommonPageRender from '@home/components/CommonPageRender';
import { getStudioGamePageConfigPath } from './configUtils';
import { PAGE_CONFIG } from './pageConfig';

interface IAuthPathRouteParams {
  studioId?: string;
  gameCode?: string;
}

/** 单独左侧菜单 AuthPath 的配置化路由入口。 */
const AuthPath = () => {
  const location = useLocation();
  const { studioId = '', gameCode = '' } = useParams<IAuthPathRouteParams>() || {};
  const reqParams = useMemo(
    () => getStudioGamePageConfigPath(location.pathname),
    [location.pathname],
  );

  return (
    <CommonPageRender
      key={`${studioId}-${gameCode}-${reqParams}`}
      reqParams={reqParams}
      frameType="game"
      pageConfigInit={PAGE_CONFIG}
    />
  );
};

export default AuthPath;
